module.exports = __webpack_public_path__ + "img/empilhadeiras_pag10.f734fce6.jpg";